import React from "react";
import "./styles.css";
import bg from './ImagenesBannerNomina/banner_header_nomina.jpg';
import logo from './ImagenesBannerNomina/logo_banner_nomina.png';
export default function BannerNomina(props) {
    

    return (
        <>
            <div className="contenedorGeneralBannerNOMINA">
                <div className="contenedorPrincipalBannerNOMINA">
                <img src={bg}/>
                    <div className="contenedorTextoBannerNOMINA">
                        <img src={logo}/>
                    </div>
                </div>
            </div>
        </>
    );
}